import chapters from './game/chapters'
import files from './game/files'
import inGameTime from './game/inGameTime'
import inventory from './game/inventory'
import map from './game/map'
import player from './game/player'
import radios from './game/radios'
import radioTransmissions from './game/radioTransmissions'

import notebook from './notebook'
import userPreferences from './userPreferences'

export default {
  chapters,
  files,
  inGameTime,
  inventory,
  map,
  player,
  radios,
  radioTransmissions,

  notebook,
  userPreferences
}
